import type { OrderDetailsExtended } from 'app/src/model'
import { membershipCollection } from 'app/src/msw/membership/initialSeed/membership'
import { transfersCollection } from 'app/src/msw/moneytransfer/initialSeed/transfers'
import { createNewTransfer } from 'app/src/msw/moneytransfer/utils/transferUtils'
import { refundCollection } from 'app/src/msw/refund/initialSeed/refund'
import { createNewRefund } from 'app/src/msw/refund/utils/refundUtils'
import { apiBaseUrl } from 'app/src/msw/shopping/api/apiBaseUrl'
import {
  discountOrdersCollection,
  giftCardsOrdersCollection,
  goodAndServiceOrdersCollection,
  refundsOrdersCollection,
  transfersOrdersCollection,
  vouchersOrdersCollection,
} from 'app/src/msw/shopping/initialSeed/orders'
import { generateOrderId } from 'app/src/msw/shopping/utils/generateOrderId'
import { getDetailPageUrl } from 'app/src/msw/shopping/utils/getDetailPageUrl'
import { updateCredit } from 'app/src/msw/shopping/utils/updateCredit'
import type { shoppingApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

export const activateProduct = http.post<object, shoppingApi.ActivateRequest, shoppingApi.ActivateResult>(
  apiBaseUrl + '/activate',
  async ({ request }) => {
    const bodyReq = await request.json()

    console.log('activateProduct bodyReq', bodyReq)

    const activeMembership = JSON.parse(sessionStorage.getItem('selectedCampaign') || '{}')
    console.log('activeMembership', activeMembership)

    const membership = membershipCollection.findFirst((q) => q.where({ membershipId: activeMembership.membershipId }))

    console.log('activateProduct membership', membership)

    const orderId = generateOrderId()
    const order: OrderDetailsExtended = {
      ...bodyReq,
      orderId,
      status: 'draft',
      isCancelable: true,
      userInfo: {
        userId: membership?.userId || 'bartolomeo.ovilipo@posteitaliane.it',
        firstName: membership?.userFirstName || 'Bartolomeo',
        lastName: membership?.userLastName || 'Ovilio',
        email: membership?.userEmail || 'bartolomeo.ovilipo@posteitaliane.it',
        fiscalCode: membership?.userFiscalCode || 'BRTLVO80A01H501C',
        membershipId: membership?.membershipId || 'fgh',
      },
      priceDetails: {
        grossPrice:
          bodyReq.variant.priceDetails?.finalGrossPrice !== undefined && bodyReq.variant.priceDetails?.finalGrossPrice >= 0
            ? bodyReq.variant.priceDetails.finalGrossPrice
            : 20,
        netPrice:
          bodyReq.variant?.priceDetails?.facePrice !== undefined && bodyReq.variant?.priceDetails?.facePrice >= 0
            ? bodyReq.variant.priceDetails?.facePrice
            : 20,
        taxPercentage:
          bodyReq.variant.priceDetails?.taxPercentage !== undefined && bodyReq.variant.priceDetails?.taxPercentage >= 0
            ? bodyReq.variant.priceDetails.taxPercentage
            : 20,
        taxAmount: 0,
        taxClass: bodyReq.variant.priceDetails?.taxClass,
        discountType: bodyReq.variant.priceDetails?.discountType,
        discountValue: bodyReq.variant.priceDetails?.discountValue,
      },
      orderDate: new Date().toISOString(),
      detailPageUrl: getDetailPageUrl(
        bodyReq.product.typology,
        orderId,
        bodyReq.product.typology === 'moneyTransfer' ? bodyReq.product.externalId : undefined,
      ),
      beneficiaries: bodyReq.beneficiaries,
      ...(bodyReq.product.typology === 'goodAndService' ? { externalPageUrl: `#/demoExternalOrder/${orderId}` } : {}),
      ...(bodyReq.product.typology === 'discount'
        ? { purchaseDetails: { typology: 'discount', purchaseDate: new Date().toISOString(), purchaseDescription: '' } }
        : {}),
    }

    if (order.product.typology === 'discount') {
      await discountOrdersCollection.create(order)
    } else if (order.product.typology === 'giftCard') {
      await giftCardsOrdersCollection.create(order)
    } else if (order.product.typology === 'goodAndService') {
      await goodAndServiceOrdersCollection.create(order)
    } else if (order.product.typology === 'voucher') {
      await vouchersOrdersCollection.create(order)
    } else if (order.product.typology === 'moneyTransfer') {
      const transfer = createNewTransfer(order, membership!)
      await transfersOrdersCollection.create(order)
      await transfersCollection.create(transfer)
    } else if (order.product.typology === 'refund') {
      const refund = createNewRefund(order, membership!)
      await refundsOrdersCollection.create(order)
      await refundCollection.create(refund)
    }

    console.log('activateProduct order', giftCardsOrdersCollection.findMany())

    if (order.product.typology === 'goodAndService') {
      const goodAndServiceOrder = goodAndServiceOrdersCollection.findFirst((q) => q.where({ orderId: order.orderId }))
      if (goodAndServiceOrder) {
        await goodAndServiceOrdersCollection.update(goodAndServiceOrder, {
          data(order) {
            order.status = 'confirmed'
          },
        })

        try {
          await updateCredit(order)
        } catch (error) {
          console.error('Error starting order:', error)
          return HttpResponse.json(
            {
              method: 'GET',
              url: '',
            },
            { status: 409 },
          )
        }
      }
    }

    return HttpResponse.json({
      method: 'GET',
      url: order.product.typology === 'goodAndService' ? order.externalPageUrl! : order.detailPageUrl,
      target: order.product.typology === 'goodAndService' ? '_blank' : '_self',
    })
  },
)
